<form
  class="form login-form"
  [formGroup]="form"
>

  @if (state() === 'login-request' || state() === 'login-password' || state() === 'reset-password-login') {
    <div class="g-form-control">
      @let loginControl = form.controls.login;

      <label class="g-form-label" for="login">{{ 'login_form.phone_or_email' | translate }}</label>
      <input
        class="g-form-input"
        [class.g-form-input-invalid]="isControlInvalid(loginControl)"
        [formControl]="loginControl"
        id="login"
        type="text"
        [mask]="isPhoneLogin() ? '+00 (000) 000-00-00000000000' : null"
        autocomplete="username"
        [placeholder]="'login_form.phone_or_email_placeholder' | translate"
      >

      @if (isControlInvalid(loginControl)) {
        <div class="g-form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  }

  @if (state() === 'types-selection') {
    <div class="login-form-header">
      {{ 'login_form.select_auth_method' | translate }}
    </div>

    <div class="selection-types">
      @for (loginTypeDto of allAvailableLoginTypes(); track $index) {
        <tc-form-radio-input
          [inputId]="loginTypeDto.loginType + '-' + (loginTypeDto.otpDestinationType || '') + '-' + $index"
          inputName="login-type"
          [inputValue]="$index"
          [inputFormControl]="selectedLoginTypeIndexControl"
        >
          <div class="selection-type-text">
            <ng-container *ngTemplateOutlet="loginTypeTextTmpl; context: { loginTypeDto: loginTypeDto, isShortLabel: false }"></ng-container>
          </div>
        </tc-form-radio-input>
      }
    </div>
  }

  @if (state() === 'otp') {
    <div class="login-form-header">
      {{ 'global.otp' | translate }}
    </div>

    <tc-otp
      class="otp"
      [otpDigitsFormArray]="form.controls.otpDigits"
      [otpRequest]="sentOtpRequest()"
      [isLoading]="isLoading()"
      [error]="error()"
      (submitted)="submit()"
      (resendOtp)="resendOtp()"
    />
  }

  @if (state() === 'login-password') {
    <div class="g-form-control">
      @let passwordControl = form.controls.password;

      <label
        class="g-form-label"
        for="password"
      >
        @if (state() === 'login-password') {
          {{ 'global.password' | translate }}
        } @else {
          {{ 'global.new_password' | translate }}
        }
      </label>
      <input
        class="g-form-input"
        [class.g-form-input-invalid]="isControlInvalid(passwordControl)"
        [formControl]="passwordControl"
        id="password"
        type="password"
        autocomplete="current-password"
      >

      @if (isControlInvalid(passwordControl)) {
        <div class="g-form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  }

  @if (state() === 'reset-password-confirm') {
    <tc-reset-password
      [login]="form.controls.login.getRawValue()"
      (success)="loggedIn.emit()"
    />
  }

  @if (state() !== 'otp' && state() !== 'reset-password-confirm') {
    @if (error()) {
      <div class="g-form-error">
        {{ error() }}
      </div>
    }

    <tc-button
      class="login-form-submit"
      [isLoading]="isLoading()"
      buttonSize="large"
      buttonType="submit"
      (click)="submit()"
    >
      @if (state() === 'reset-password-login') {
        {{ 'global.send_otp' | translate }}
      } @else {
        {{ 'login_form.next' | translate }}
      }
    </tc-button>
  }

  @if (state() === 'login-password') {
    <button
      class="g-main-link login-action"
      (click)="changeState('reset-password-login')"
      [disabled]="isLoading()"
    >
      {{ 'login_form.forgot_password' | translate }}
    </button>
  }

  @if (state() === 'reset-password-login' || (state() === 'reset-password-confirm' && resetPasswordComponent()?.state() !== 'success')) {
    <button
      class="g-main-link login-action"
      (click)="changeState('login-password')"
      [disabled]="isLoading()"
    >
      {{ 'login_form.remembered_password' | translate }}
    </button>
  }

  @if (state() === 'login-request') {
    <div class="delimiter">
      <div class="delimiter-text">{{ 'global.or' | translate }}</div>
    </div>

    <div class="socials">
      <button
        class="login-type"
        (click)="loginByOauth('google')"
        type="button"
      >
        <tc-icon
          class="social-icon social-icon-google"
          name="google"
        />

        {{ 'login_form.by_google' | translate }}
      </button>

      <button
        class="login-type"
        (click)="loginByOauth('facebook')"
        type="button"
      >
        <tc-icon
          class="social-icon social-icon-facebook"
          name="facebook"
        />

        {{ 'login_form.by_facebook' | translate }}
      </button>
    </div>
  }

  @if (state() === 'otp' || state() === 'login-password') {
    @if (notSelectedAvailableLoginTypes().length) {
      <div class="delimiter">
        <div class="delimiter-text">{{ 'global.or' | translate }}</div>
      </div>

      <div class="additional-login-types">
        @for (loginTypeDto of notSelectedAvailableLoginTypes(); track $index) {
          <button
            class="login-type additional"
            (click)="loginByType(loginTypeDto)"
            [disabled]="isLoading()"
          >
            <ng-container *ngTemplateOutlet="loginTypeTextTmpl; context: { loginTypeDto: loginTypeDto, isShortLabel: true }"></ng-container>
          </button>
        }
      </div>
    }
  }

  @if (state() !== 'login-request' && resetPasswordComponent()?.state() !== 'success') {
    <button
      class="g-main-link login-action"
      (click)="back()"
    >
      {{ 'global.back' | translate }}
    </button>
  }
</form>

<ng-template
  #loginTypeTextTmpl
  let-loginTypeDto="loginTypeDto"
  let-isShortLabel="isShortLabel"
>
  @let loginTypeDtoTyped = getTypedLoginTypeDto(loginTypeDto);

  @switch (loginTypeDtoTyped.loginType) {
    @case (LoginType.Password) {
      <tc-icon
        class="login-type-icon"
        name="password"
      />
      <div class="login-type-text">
        {{ 'login_form.login_with_password' | translate }}
      </div>
    }
    @default {
      <tc-icon
        class="login-type-icon"
        [name]="loginTypeDtoTyped.otpDestinationType"
      />
      <div class="login-type-text">
        {{ `login_form.send_otp_${loginTypeDtoTyped.otpDestinationType}${isShortLabel ? '_short' : ''}` | translate }}
        <span class="login-type-destination"> {{ loginTypeDtoTyped.otpDestination }}</span>
      </div>
    }
  }
</ng-template>
